<template>
  <div class="search-bar">
    <input v-model="searchValue" type="text" class="form-control search-input" :placeholder="placeholder"
      @input="onInput" />
    <svg class="search-icon" width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
      <path
        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Search...'
    },
    debounce: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      searchValue: this.modelValue,
      debounceTimer: null
    }
  },
  beforeUnmount() {
    clearTimeout(this.debounceTimer)
  },
  watch: {
    modelValue(newValue) {
      this.searchValue = newValue
    }
  },
  methods: {
    onInput() {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.$emit('update:modelValue', this.searchValue)
      }, this.debounce)
    }
  },
  emits: ['update:modelValue'],
}
</script>

<style scoped>
.search-bar {
  position: relative;
  display: inline-block;
  width: 100%;
}

.search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
}

.search-input {
  padding-left: 32px;
}
</style>
